// extracted by mini-css-extract-plugin
export var logo = "logo-module--logo--cf951";
export var text = "logo-module--text--bb7c0";